/* Warenkorb & Cart-Drawer, zwei Ergaenzungen:

   1) Gratis-Versand-Hinweis ueber der Summe:
      "Noch X EUR bis Gratis-Versand" bzw. "Gratis-Versand erreicht",
      mit schmalem Fortschrittsbalken. Schwelle muss zur Shopify-
      Versandregel passen (Versand > Deutschland > DHL Paket (Klein),
      gratis ab 35,00 EUR).

   2) Cross-Sell: liegt der Kennzeichenhalter im Warenkorb, aber
      nicht das Ersatzschrauben-Set, erscheint eine Karte mit
      "Hinzufuegen"-Button. Wird das Set hinzugefuegt oder ist es
      ausverkauft, verschwindet die Karte von selbst.

   Beide Bausteine lesen den Warenkorb live aus /cart.js, damit
   Rabatte korrekt beruecksichtigt sind.

   Defensiv: schlaegt etwas fehl, bleibt der Warenkorb unveraendert. */
(function () {
  var FREE_FROM_CENTS = 3500;   // Gratis-Versand ab 35,00 EUR

  /* Cross-Sell: Ausloeser-Produkte (Product-IDs) und das
     angebotene Zusatzprodukt (Handle). Weitere Ausloeser einfach
     in die Liste aufnehmen. */
  var UPSELL_TRIGGER_PRODUCT_IDS = [15885325336907]; // Max G3 Quick Release Kennzeichenhalter
  var UPSELL_HANDLE = 'ersatzschrauben-set-fur-max-g3';
  var UPSELL_HEADLINE = 'Schrauben verloren oder ausgeleiert?';

  var lastCart = null;
  var addon = null;        // Produktdaten des Zusatzprodukts
  var addonLoaded = false;
  var fetching = false;
  var adding = false;
  var timer = null;

  function euro(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function root() {
    try {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        return window.Shopify.routes.root;
      }
    } catch (e) {
      /* still */
    }
    return '/';
  }

  function hosts() {
    return document.querySelectorAll('.cart-totals');
  }

  /* ---------- Gratis-Versand ---------- */

  function buildFreeship() {
    var box = document.createElement('div');
    box.className = 'jt-freeship-cart';

    var text = document.createElement('p');
    text.className = 'jt-freeship-cart__text';
    box.appendChild(text);

    var track = document.createElement('span');
    track.className = 'jt-freeship-cart__track';
    var fill = document.createElement('span');
    fill.className = 'jt-freeship-cart__fill';
    track.appendChild(fill);
    box.appendChild(track);

    return box;
  }

  function renderFreeship(host, total) {
    var box = host.querySelector('.jt-freeship-cart');
    if (!box) {
      box = buildFreeship();
      host.insertBefore(box, host.firstChild);
    }

    var text = box.querySelector('.jt-freeship-cart__text');
    var fill = box.querySelector('.jt-freeship-cart__fill');
    if (!text || !fill) return;

    var remaining = FREE_FROM_CENTS - total;
    if (remaining <= 0) {
      box.classList.add('jt-freeship-cart--reached');
      text.textContent = 'Gratis-Versand erreicht — Versand 0,00 €';
    } else {
      box.classList.remove('jt-freeship-cart--reached');
      text.textContent =
        'Noch ' + euro(remaining) + ' bis Gratis-Versand (ab ' + euro(FREE_FROM_CENTS) + ')';
    }

    var pct = Math.round((total / FREE_FROM_CENTS) * 100);
    if (pct < 0) pct = 0;
    if (pct > 100) pct = 100;
    fill.style.width = pct + '%';
  }

  /* ---------- Cross-Sell ---------- */

  function loadAddon() {
    if (addonLoaded) return;
    addonLoaded = true;
    fetch(root() + 'products/' + UPSELL_HANDLE + '.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (product) {
        addon = product;
        if (lastCart) renderAll(lastCart);
      })
      .catch(function () {
        addon = null;
      });
  }

  /* true, wenn ein Ausloeser-Produkt im Warenkorb liegt und das
     Zusatzprodukt noch nicht. */
  function upsellNeeded(cart) {
    if (!cart || !cart.items || !cart.items.length) return false;
    var hasTrigger = false;

    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (item.handle === UPSELL_HANDLE) return false;
      for (var j = 0; j < UPSELL_TRIGGER_PRODUCT_IDS.length; j++) {
        if (item.product_id === UPSELL_TRIGGER_PRODUCT_IDS[j]) hasTrigger = true;
      }
    }
    return hasTrigger;
  }

  function addonVariant() {
    if (!addon || !addon.variants || !addon.variants.length) return null;
    for (var i = 0; i < addon.variants.length; i++) {
      if (addon.variants[i].available) return addon.variants[i];
    }
    return null;
  }

  function addAddon(button) {
    var variant = addonVariant();
    if (!variant || adding) return;
    adding = true;
    button.disabled = true;
    button.textContent = 'Wird hinzugefügt …';

    function done() {
      adding = false;
      scheduleRefresh();
    }

    try {
      if (window.Shopify && window.Shopify.actions && window.Shopify.actions.updateCart) {
        window.Shopify.actions
          .updateCart(
            { lines: [{ merchandiseId: String(variant.id), quantity: 1 }] },
            { event: { context: 'cart' } }
          )
          .then(done)
          .catch(done);
        return;
      }
    } catch (e) {
      /* Fallback unten */
    }

    /* Fallback ohne Shopify.actions: klassisch hinzufuegen und die
       Seite neu laden, damit der Warenkorb sicher aktuell ist. */
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
    })
      .then(function () {
        window.location.reload();
      })
      .catch(done);
  }

  function buildUpsell() {
    var box = document.createElement('div');
    box.className = 'jt-upsell';

    var media = document.createElement('span');
    media.className = 'jt-upsell__media';
    box.appendChild(media);

    var body = document.createElement('div');
    body.className = 'jt-upsell__body';

    var head = document.createElement('strong');
    head.className = 'jt-upsell__head';
    head.textContent = UPSELL_HEADLINE;
    body.appendChild(head);

    var name = document.createElement('span');
    name.className = 'jt-upsell__name';
    body.appendChild(name);

    box.appendChild(body);

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'jt-upsell__button';
    button.textContent = 'Hinzufügen';
    button.addEventListener('click', function () {
      addAddon(button);
    });
    box.appendChild(button);

    return box;
  }

  function removeUpsell(host) {
    var stale = host.parentNode ? host.parentNode.querySelectorAll('.jt-upsell') : [];
    for (var i = 0; i < stale.length; i++) {
      if (stale[i].parentNode) stale[i].parentNode.removeChild(stale[i]);
    }
  }

  function renderUpsell(host, cart) {
    var variant = upsellNeeded(cart) ? addonVariant() : null;

    if (!variant) {
      removeUpsell(host);
      return;
    }
    if (!host.parentNode) return;

    var box = host.parentNode.querySelector('.jt-upsell');
    if (!box) {
      box = buildUpsell();
      host.parentNode.insertBefore(box, host);
    }

    var media = box.querySelector('.jt-upsell__media');
    var name = box.querySelector('.jt-upsell__name');
    var button = box.querySelector('.jt-upsell__button');

    if (media && addon.featured_image && !media.querySelector('img')) {
      var img = document.createElement('img');
      img.src = addon.featured_image;
      img.alt = '';
      img.loading = 'lazy';
      media.appendChild(img);
    }
    if (name) {
      name.textContent = addon.title + ' — ' + euro(variant.price);
    }
    if (button && !adding) {
      button.disabled = false;
      button.textContent = 'Hinzufügen';
    }
  }

  /* ---------- Gemeinsam ---------- */

  function renderAll(cart) {
    try {
      if (!cart) return;
      var list = hosts();
      for (var i = 0; i < list.length; i++) {
        renderFreeship(list[i], cart.total_price);
        renderUpsell(list[i], cart);
      }
    } catch (e) {
      /* still */
    }
  }

  function refresh() {
    try {
      if (!hosts().length || fetching) return;
      fetching = true;
      fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          fetching = false;
          lastCart = cart;
          if (upsellNeeded(cart)) loadAddon();
          renderAll(cart);
        })
        .catch(function () {
          fetching = false;
        });
    } catch (e) {
      fetching = false;
    }
  }

  function scheduleRefresh() {
    window.clearTimeout(timer);
    timer = window.setTimeout(refresh, 350);
  }

  function start() {
    refresh();
    try {
      new MutationObserver(function () {
        window.requestAnimationFrame(function () {
          /* Nach dem Neurendern des Warenkorbs sofort mit dem
             letzten bekannten Stand wieder einsetzen, dann den
             frischen Warenkorb nachladen. */
          var list = hosts();
          for (var i = 0; i < list.length; i++) {
            if (!list[i].querySelector('.jt-freeship-cart')) {
              renderAll(lastCart);
              break;
            }
          }
          scheduleRefresh();
        });
      }).observe(document.body, { subtree: true, childList: true });

      document.addEventListener('shopify:cart:lines-update', scheduleRefresh);
      document.addEventListener('cart:update', scheduleRefresh);
      window.addEventListener('pageshow', scheduleRefresh);
    } catch (e) {
      /* still */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
